export const Loyaltic = {
    API: {
        CaptureEmail: 'api/v1/capturereminderemail',
        LiveConfig: 'api/v1/liveconfig',
        Login: 'api/v1/login',
        Upload: 'api/v1/upload',
        AvailableGames: 'api/v1/user/availablegames',
        AvailableSlots: 'api/v1/user/availableslots',
        CheckCode: 'api/v1/user/checkcode',
        GetRewards: 'api/v1/rewards',
        HasGames: 'api/v1/user/hasgames',
        LoginWithUploadReceipt: 'api/v1/user/regwithupload',
        Play: 'api/v1/play',
        TestWin: 'api/v1/testwin',
        CaptureAddress: 'api/v1/captureaddress',
        CaptureDigitalWin: 'api/v1/capturedigitalwin',
        Phonenumberexists: 'api/v1/user/phonenumberexists',
        Emailreminder: 'api/v1/capturereminderemail',
        RegUploadWithRealTimeScanning: 'api/v1/user/regwithrealtimescanningandupload',
        Participate: 'api/v1/participate',
        UploadWithRealTimeScanning: 'api/v1/user/uploadwithrealtimescanning',
        confirmuploadafterscanning: 'api/v1/upload/confirm',
        LocalizationByCulture: 'api/v1/LocalizationByCulture',
        LocalizationByPage: 'api/v1/LocalizationByPage',
        SendFeedback: 'api/v1/sendfeedback',
        UserEmailPhone: 'api/v1/user/username',
        Localization: {
            Controller: 'Admin/',
            Actions: {
                LocalizationByPage: 'LocalizationByPage',
                AddNewGlobalLocalization: 'AddNewGlobalLocalization',
                UpdateGlobalLocalization: 'UpdateGlobalLocalization',
                LocalizationByCulture: 'LocalizationByCulture',
            }
        },
        Analytics: {
            RegistrationsDailyTrend: 'api/v1/analytics/registrations/daily-fast',
            RegistrationsWeeklyTrend: 'api/v1/analytics/registrations/weekly-fast',
            RegistrationsSummary: 'api/v1/analytics/registrations/summary-fast',
            MarketingEmailsDailyTrend: 'api/v1/analytics/marketing-emails/daily-fast',
            MarketingEmailsWeeklyTrend: 'api/v1/analytics/marketing-emails/weekly-fast',
            MarketingEmailsSummary: 'api/v1/analytics/marketing-emails/summary-fast',
            SlotsDailyTrend: 'api/v1/analytics/slots/daily-fast',
            SlotsWeeklyTrend: 'api/v1/analytics/slots/weekly-fast',
            SlotsSummary: 'api/v1/analytics/slots/summary-fast',
            GamesDailyTrend: 'api/v1/analytics/games/daily-fast',
            GamesWeeklyTrend: 'api/v1/analytics/games/weekly-fast',
            GamesSummary: 'api/v1/analytics/games/summary-fast',
            RewardsDailyTrend: 'api/v1/analytics/rewards/daily-fast',
            RewardsWeeklyTrend: 'api/v1/analytics/rewards/weekly-fast',
            RewardsSummary: 'api/v1/analytics/rewards/summary-fast'
        }
    },
    WithOutReceiptRedirectUrl: '#'
};
